<div *ngIf="widget && widget.data" class="u-flex u-wrap">
  <span *ngFor="let columns of widget.data" class="col-12 u-wrap" [innerHTML]="columns.column_text"
    [ngClass]="{'col-md-12': widgetColumns === 1, 'col-md-6': widgetColumns === 2 || widgetColumns === 3, 'col-xl-4 col-md-3': widgetColumns === 4, 'col-xl-2 col-md-6': widgetColumns >= 5 }">
  </span>
